// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qf_a bhf_su bhf_kv bhf_kw","PostDetailRight__brandDaysPosts":"qf_b bhf_su bhf_kv bhf_kw"};